import React from 'react';

import useEvent from '@lyearn/core/hooks/useEvent';
import { cn } from '@lyearn/style';
import * as Editor from '@/components/Editor/PlainEditor/components/Editor';
import Loader from '@/components/Loader';
import { EntityMediaFragment } from '@/features/messages/graphql/fragments/generated/MediaType';
import { hideImageSeparator } from '@/modules/corporate/modules/channel/views/ChannelDetails/components/MessageInput/styles';
import { MentionInputType } from '@/types/schema';

import {
  PRAISE_MESSAGE_EDITOR_DEFAULT_OPTIONS,
  PRAISE_MESSAGE_EDITOR_OPTION_MAP,
  PRAISE_MESSAGE_EXTENSIONS,
  PRAISE_MESSAGE_PLUGINS,
} from './consts';
import { editorStyles } from './styles';
import { PraiseMessageProps } from './types';

const PraiseMessage: React.FC<PraiseMessageProps> = (props) => {
  const {
    value,
    onChange,
    medias,
    error,
    setFieldValue,
    placeholder,
    editorOptions = PRAISE_MESSAGE_EDITOR_DEFAULT_OPTIONS,
  } = props;

  const onChangeText = useEvent((text: string) => {
    onChange(text);
  });

  const onChangeMedias = useEvent((medias: EntityMediaFragment[]) => {
    setFieldValue('medias', medias, true);
  });

  const onChangeMentions = useEvent((mentions: MentionInputType[]) => {
    setFieldValue('mentions', mentions, true);
  });

  return (
    <React.Suspense fallback={<Loader />}>
      <Editor.Main
        enableMentions
        className={cn(
          'relative flex flex-col overflow-hidden rounded-8 border focus-within:border-focus-primary',
          error ? 'border-border-error-dark' : 'border-field',
          hideImageSeparator,
        )}
        defaultValue={value}
        extensions={PRAISE_MESSAGE_EXTENSIONS}
        medias={medias}
        placeholder={placeholder}
        plugins={PRAISE_MESSAGE_PLUGINS}
        onChangeMedias={onChangeMedias}
        onChangeMentions={onChangeMentions}
        onChangeText={onChangeText}>
        <Editor.EditorCore
          className={cn('flex-1 overflow-y-auto overscroll-y-contain', editorStyles)}
          variant="body-short-01"
        />
        {medias.length > 0 ? <Editor.AttachmentContainer /> : null}
        <Editor.Toolbar
          editorOptionMap={PRAISE_MESSAGE_EDITOR_OPTION_MAP}
          editorOptions={editorOptions}
        />
      </Editor.Main>
    </React.Suspense>
  );
};

export default PraiseMessage;
